import { BrandKit } from "@redotech/redo-content-builder-common/brand-kit";
import { memo } from "react";
import { Card } from "./card";
import { Flex } from "./flex";
import { Text } from "./text";
import { BgColorValue } from "./theme/box";

export const ContactCard = memo(function ContactCard({
  brandKit,
  bgColor = "tertiary",
}: {
  brandKit: BrandKit | undefined;
  bgColor?: BgColorValue;
}) {
  const contactCard = brandKit?.contactCard;
  if (!contactCard || !contactCard.contactCardSrc) {
    return null;
  }
  const { firstName, lastName, logoUrl } = contactCard;
  const initials =
    `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return (
    <Card
      bgColor={bgColor}
      borderColor="primary"
      borderRadius="sm"
      height="fit-content"
      p="xs"
    >
      <Flex justify="space-between">
        <Flex dir="column" gap="xxs" p="sm">
          <Text fontSize="xs" fontWeight="semibold" textColor="primary">
            {fullName}
          </Text>
          <Text fontSize="xxs" textColor="secondary">
            Contact card
          </Text>
        </Flex>
        {logoUrl ? (
          <img
            alt={initials}
            data-web="ContactCard"
            src={logoUrl}
            style={{
              width: 40,
              height: 40,
              objectFit: "cover",
              borderRadius: "var(--border-radius-full)",
            }}
          />
        ) : (
          <div
            style={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "var(--redo-colors-gray-light-mode-300)",
              borderRadius: "var(--border-radius-full)",
              fontSize: "var(--redo-font-size-md)",
              color: "var(--redo-colors-text-text-white)",
              fontWeight: "var(--redo-font-weight-bold)",
            }}
          >
            {initials}
          </div>
        )}
      </Flex>
    </Card>
  );
});
